/*global define*/
define('all/feature-toggles',['module'], function (module) {
	'use strict';

	var configuration = module.config();

	function isActive(feature) {
		return configuration[feature];
	}

	return {
		isActive: isActive
	};
});

